// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function WarningIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M29.6 23.511 18.669 4.527a3.095 3.095 0 0 0-5.338 0L2.4 23.511a2.939 2.939 0 0 0 0 2.965A3.044 3.044 0 0 0 5.069 28H26.93a3.043 3.043 0 0 0 2.666-1.524 2.938 2.938 0 0 0 .003-2.965Zm-1.734 1.964a1.063 1.063 0 0 1-.935.525H5.07a1.062 1.062 0 0 1-.935-.525.949.949 0 0 1 0-.965L15.065 5.526a1.094 1.094 0 0 1 1.875 0L27.871 24.51a.948.948 0 0 1-.005.965ZM15 18v-5a1 1 0 0 1 2 0v5a1 1 0 0 1-2 0Zm2.5 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
